var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicPenBlueOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E4E6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0054 21.5564C25.6711 21.6605 25.3109 21.8085 24.9555 22.019C24.1449 22.4992 23.3906 23.2873 23.0138 24.5382C22.6378 23.2807 21.8825 22.4909 21.0695 22.0114C20.7111 21.7999 20.3477 21.6522 20.0111 21.5491C20.3398 21.4465 20.6935 21.3013 21.0427 21.0958C21.8572 20.6164 22.616 19.8265 22.9937 18.568C23.3717 19.8266 24.1311 20.6167 24.9476 21.096C25.3058 21.3063 25.6688 21.4535 26.0054 21.5564Z",
    fill: "#035FC4",
    stroke: "#035FC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3601 16.4293C17.9029 16.6981 17.4818 17.135 17.2601 17.8141C17.0419 17.125 16.6207 16.6822 16.1605 16.4105C15.9735 16.3001 15.7843 16.2204 15.6065 16.1628C15.7818 16.1055 15.9681 16.0266 16.1526 15.9182C16.6192 15.644 17.0481 15.1946 17.266 14.4916C17.4838 15.1946 17.9128 15.644 18.3794 15.9182C18.5725 16.0318 18.7678 16.1129 18.9501 16.1708C18.7623 16.229 18.5601 16.3118 18.3601 16.4293Z",
    fill: "#035FC4",
    stroke: "#035FC4",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9495 25.0746C13.7625 24.9642 13.5734 24.8844 13.3956 24.8268C13.5708 24.7695 13.7572 24.6907 13.9416 24.5823C14.4082 24.3081 14.8372 23.8587 15.055 23.1557C15.2729 23.8587 15.7018 24.3081 16.1684 24.5823C16.3616 24.6958 16.5568 24.7769 16.7392 24.8348C16.5514 24.8931 16.3492 24.9758 16.1492 25.0934C15.6919 25.3621 15.2708 25.7991 15.0491 26.4782C14.831 25.789 14.4098 25.3463 13.9495 25.0746Z",
    fill: "#035FC4",
    stroke: "#035FC4",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicPenBlueOptions);
export default __webpack_public_path__ + "static/media/magicPenBlueOptions.1b75e342df1e5ceab98bb3898f29ad13.svg";
export { ForwardRef as ReactComponent };